const skillsActionConstants = {
  GET_SKILLS: 'GET_SKILLS',
};

export default skillsActionConstants;
